export default __webpack_public_path__ + "assets/images/2c35ffdfd7d87a89092f3b14ab8b92e8.jpg";